import React, {Component} from 'react';
import {Panel, Col} from 'react-bootstrap';
import classnames from 'classnames';
import MessageHeader from './message-header';
import MessageSender from './message-sender';
import MessageBody from './message-body';
import MessageDate from './message-date';
import MessageFooter from './message-footer';
import {MESSAGE_RECEIVED} from '../../data/messageTypes';
import MessageSubject from './message-subject';

class Message extends Component {
  state = {};

  toggleMessage = () => {
    const {message, opened, onMessageOpened} = this.props;
    onMessageOpened(message.id, !opened, message.attributes.read);
  };

  toggleReplyAndOpen = () => {
    const {
      message, opened, toggleReply, onMessageOpened
    } = this.props;

    onMessageOpened(message.id, !opened, message.attributes.read);
    toggleReply(true, message);
  };

  showMessage = () => {
    const {
      message, opened, small, area
    } = this.props;
    const {body, 'system-message': system} = message.attributes;
    let content = small && opened ? body : this.trimBody(body);

    if (area === 'retailer') {
      content = opened ? body : this.trimBody(body);
    }

    if (!system) {
      content = content.replace(/\n/g, '<br>');
    }

    if (!(small && opened)) {
      content = this.stripHtmlTags(content);
    }

    return <div dangerouslySetInnerHTML={{__html: content}}/>;
  };

  stripHtmlTags = content => content.replace(/<(?:.|\n)*?>/gm, '');

  trimBody = body => (body.length > 40 ? body.slice(0, 40)
    .concat('…') : body);

  render() {
    const {
      message, opened: open, onMessageChecked, onDelete, checked, openedDetails, reply, replyComponent, messageType
    } = this.props;

    const body = this.showMessage();

    const panelClassNames = classnames({
      'message-item': true,
      open,
      reply: reply && messageType === MESSAGE_RECEIVED,
      unread: !message.attributes.read && messageType === MESSAGE_RECEIVED,
    });

    const footer = (
      <MessageFooter
        toggleMessage={this.toggleMessage}
        open={open}
        message={message}
        onDelete={onDelete}
        reply={messageType === MESSAGE_RECEIVED && !message.attributes['system-message']}
        toggleReply={this.toggleReplyAndOpen}
      />
    );


    return (
      <Col onClick={this.toggleMessage}>
        <Panel className={panelClassNames} footer={footer}>

          <MessageHeader
            onMessageChecked={onMessageChecked}
            checked={checked}
            message={message}
            checkbox={messageType === MESSAGE_RECEIVED}
          />

          <MessageSubject message={message}/>

          <MessageSender type={messageType} message={message}/>

          <MessageBody>{body}</MessageBody>

          <MessageDate message={message}/>

          {open && openedDetails}

          {reply && replyComponent}
        </Panel>
      </Col>
    );
  }
}

export default Message;



// WEBPACK FOOTER //
// ./src/components/my-messages/message.jsx